import { AdminArea } from '../types';
import { AdminAreaLink, ClimbingAreaLink } from './common';

interface AdminAreaProps {
    adminArea: AdminArea
    /// Link the state name to its own page (when listing every state)
    linkHeading?: boolean
}

/// One state's areas as a card of links
const AdminAreaSection = ({ adminArea, linkHeading = false }: AdminAreaProps) => {
    return (
        <section className="cw-card state-areas" id={adminArea.code} aria-labelledby={`state-${adminArea.code}`}>
            <h2 className="cw-card__title state-areas__title" id={`state-${adminArea.code}`}>
                {/* On a state's own page the name is already the page title, so count instead */}
                {linkHeading
                    ? <AdminAreaLink code={adminArea.code}>{adminArea.name}</AdminAreaLink>
                    : `${adminArea.areas?.length ?? 0} areas`}
            </h2>
            <ul className="state-areas__list">
                {adminArea.areas?.map((area) => (
                    <li key={area.areaId}><ClimbingAreaLink area={area} /></li>
                ))}
            </ul>
        </section>
    );
};

export default AdminAreaSection;
